import './Home.css'
import backgroundVideo from '../images/homepage.mp4'
export default function Home(){
    return (
    <div className="page">
        <video autoPlay loop muted playsInline className="background-video">
            <source src={backgroundVideo} type="video/mp4" />
        </video>
    <div className="content_in_home">
    <h1>Welcome</h1>
    <h1>to</h1>
    <h1>High & Fly</h1>
    <p>Fly prices and HIGH quality!</p>
    </div>
    </div>
    );
}